import { lazy } from 'react';

export const TicketList = lazy(() => import('./TicketList'));
export const AddTicket = lazy(() => import('./AddTicket'));
export const TicketDetails = lazy(() => import('./TicketDetails'));
